const errorByCode: Record<string, string> = {
	NOT_FOUND: "Esse termo não existe mais.",
	NOT_MIGRATED: "Este termo ainda não foi migrado para o novo formato de páginas.",
};

export const TermosLabels = {
	rail: {
		title: "Termos",
		count(total: number) {
			return `${total} modelo${total === 1 ? "" : "s"}`;
		},
		generate: "Gerar termo",
		delete: "Excluir termo",
		deleteBody(name: string) {
			return `"${name}" será excluído e não poderá mais ser enviado.`;
		},
		deleteGenerationBody(name: string) {
			return `A geração de "${name}" será excluída.`;
		},
		deleteConfirm: "Excluir",
		deleteCancel: "Cancelar",
		deleteError: "Não foi possível excluir o termo.",
		reviewRequired: "Revisão pendente",
	},

	empty: {
		title: "Nenhum termo ainda",
		description: "Nenhum modelo de termo disponível.",
	},

	generation: {
		title: "Gerar termo com IA",
		uploadHint: "Contrato original em PDF",
		pick: "Escolher PDF",
		constraints: "PDF de até 500 KB.",
		notPdf: "O arquivo precisa ser um PDF.",
		tooLarge: "O PDF passa de 500 KB.",
		createError(code: string | undefined) {
			if (code === "INVALID_PDF") {
				return "Esse arquivo não é um PDF válido.";
			}

			return "Não foi possível iniciar a geração.";
		},

		phase(phase: string | undefined) {
			if (phase === "reading") {
				return "Lendo o contrato...";
			}

			if (phase === "writing") {
				return "Escrevendo o modelo...";
			}

			return "Na fila...";
		},
		blocks(total: number) {
			return `${total} bloco${total === 1 ? "" : "s"}`;
		},
		previewAlt: "Preview da primeira página do modelo",
		trackingHint: "A geração continua em segundo plano.",

		cancel: "Cancelar geração",
		canceled: "Geração cancelada.",

		failed: "A geração falhou.",
		retry: "Tentar de novo",
		discard: "Descartar",
		retryError: "Não foi possível reenfileirar a geração.",

		done: "Modelo pronto.",
		doneIncomplete: "Revisão automática incompleta.",
		issues: "Pontos para revisão:",
		openEditor: "Abrir no editor",

		listState: "Gerando",
	},

	review: {
		title: "Revisão do modelo",
		incompleteBody: "Conferência visual automática incompleta.",
		readyBody: "Todos os pontos foram revisados. O modelo ainda não está disponível para envio.",
		kinds: {
			source_typo: "Erro no texto original",
			legal_structure: "Estrutura jurídica",
			uncertain_binding: "Origem do dado",
			financial_consistency: "Consistência financeira",
			institutional_data: "Dado institucional",
			policy_constant: "Política jurídica",
		},
		severity: {
			blocker: "Bloqueio",
			warning: "Atenção",
			info: "Informação",
		},
		apply: "Aplicar correção",
		accept: "Confirmar ponto",
		keep: "Manter original",
		dismiss: "Descartar ponto",
		publish: "Publicar modelo",
		publishing: "Publicando...",
		resolved: "Ponto revisado.",
		published: "Modelo publicado.",
		stale: "O trecho mudou desde a geração.",
		error: "Não foi possível atualizar a revisão.",
		source: "Ver contrato original",
	},

	editor: {
		back: "Voltar",
		nameAria: "Nome do termo",
		export: "Exportar PDF",
		save: "Salvar termo",
		saved: "Salvo",
		savedToast: "Termo salvo.",
		saveFailed: "Não foi possível salvar o termo.",
		dirtyBanner: "Há edições não salvas.",
		leaveTitle: "Edições não salvas",
		leaveConfirm: "As edições não salvas serão descartadas.",
		stay: "Ficar",
		leave: "Sair mesmo assim",
	},

	image: {
		uploadError(code: string | undefined) {
			if (code === "INVALID_IMAGE") {
				return "Esse arquivo não é uma imagem PNG, JPEG ou WebP.";
			}

			if (code === "IMAGE_TOO_LARGE") {
				return "A imagem passa de 5 MB.";
			}

			return "Não foi possível enviar a imagem.";
		},
		floatError: "Não foi possível atualizar a imagem flutuante.",
	},

	customField: {
		createTitle: "Novo campo do termo",
		editTitle: "Editar campo do termo",
		createHint: "Valor definido em cada envio do termo.",
		labelLabel: "Rótulo",
		labelPlaceholder: "Ex.: Data da cirurgia",
		nameLabel: "Identificador",
		nameHint: "Identificador único no termo.",
		typeLabel: "Tipo de dado",
		create: "Criar campo",
		save: "Salvar campo",
		created: "Campo criado.",
		error(code: string | undefined) {
			if (code === "DUPLICATE_FIELD_NAME") {
				return "Já existe um campo com esse identificador neste termo.";
			}

			if (code === "NOT_FOUND") {
				return "Esse termo não existe mais.";
			}

			return "Não foi possível criar o campo.";
		},
	},

	pageOverflow(page: number) {
		return `Conteúdo fora dos limites da página ${page}.`;
	},

	error(code: string | undefined) {
		if (code === undefined) {
			return "Não foi possível carregar o termo.";
		}

		return errorByCode[code] ?? "Não foi possível carregar o termo.";
	},
};
